import React, { useEffect, useMemo, useState } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { I18n, Translate } from 'react-redux-i18n'
import * as API from '../../utility/api'

const formatDate = date => {
  if (!date) return ''

  return moment(date).format('DD.MM.YYYY')
}

const SearchAlertsConfirmPopup = ({
  eventName,
  onConfirm,
  onCancel,
  removing,
}) => {
  return (
    <div className="search-alerts-modal-backdrop">
      <div className="search-alerts-modal">
        <p>
          {I18n.t('search_alerts.remove_confirmation', {
            event: eventName,
          })}
        </p>
        <div className="search-alerts-modal-actions">
          <button onClick={onConfirm} disabled={removing}>
            <Translate value="search_alerts.remove" />
          </button>
          <button
            className="btn-blank secondary-button"
            onClick={onCancel}
            disabled={removing}
          >
            <Translate value="search_alerts.cancel" />
          </button>
        </div>
      </div>
    </div>
  )
}

const UserPageSearchAlerts = () => {
  const [searchAlerts, setSearchAlerts] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [selectedAlert, setSelectedAlert] = useState(null)
  const [removing, setRemoving] = useState(false)

  useEffect(() => {
    setLoading(true)
    setError(false)

    API.GET('subscriptions/active')
      .then(({ data }) => {
        setSearchAlerts(data.search_alerts || [])
        setLoading(false)
      })
      .catch(e => {
        if (API.isHandledAuthError(e)) {
          setLoading(false)
          return
        }

        setError(true)
        setLoading(false)
      })
  }, [])

  const rows = useMemo(() => {
    return searchAlerts.map(searchAlert => (
      <tr key={`user-search-alert-${searchAlert.id}`}>
        <td className="tl-event-table__column--l">
          <Link to={`/events/${searchAlert.event_id}`}>{searchAlert.name}</Link>
        </td>
        <td className="tl-event-table__column--l">
          {formatDate(searchAlert.start_date)}
        </td>
        <td className="tl-event-table__column--l">{searchAlert.city}</td>
        <td className="tl-event-table__column--r">
          <button onClick={() => setSelectedAlert(searchAlert)}>
            <Translate value="search_alerts.remove" />
          </button>
        </td>
      </tr>
    ))
  }, [searchAlerts])

  const removeSearchAlert = () => {
    if (!selectedAlert) {
      return
    }

    setRemoving(true)

    API.DELETE('subscriptions', {
      event_id: selectedAlert.event_id
    })
      .then(() => {
        setSearchAlerts(current =>
          current.filter(alert => alert.id !== selectedAlert.id)
        )
        setSelectedAlert(null)
        setRemoving(false)
        API.apiNotification({
          value: 'search_alerts.removed_successfully',
          status: 'success'
        })
      })
      .catch(e => {
        if (API.isHandledAuthError(e)) {
          setRemoving(false)
          return
        }

        setRemoving(false)
        API.apiNotification({
          value: 'search_alerts.remove_failed',
          status: 'error'
        })
      })
  }

  if (loading) {
    return <div>{I18n.t('search_alerts.loading')}</div>
  }

  if (error) {
    return <div>{I18n.t('search_alerts.loading_error')}</div>
  }

  return (
    <div className="userpage-info-container">
      <div className="userpage-info-window">
        <h2>
          <Translate value="search_alerts.user_title" />
        </h2>

        {searchAlerts.length === 0 ? (
          <div className="search-alerts-empty-state">
            <Translate value="search_alerts.user_empty" />
          </div>
        ) : (
          <table className="tl-event-table search-alerts-table">
            <thead>
              <tr>
                <th className="tl-event-table__column--l">
                  <Translate value="search_alerts.event_name" />
                </th>
                <th className="tl-event-table__column--l">
                  <Translate value="search_alerts.date" />
                </th>
                <th className="tl-event-table__column--l">
                  <Translate value="search_alerts.city" />
                </th>
                <th className="tl-event-table__column--r">
                  <Translate value="search_alerts.remove_search_alert" />
                </th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </table>
        )}

        {selectedAlert && (
          <SearchAlertsConfirmPopup
            eventName={selectedAlert.name}
            removing={removing}
            onConfirm={removeSearchAlert}
            onCancel={() => {
              if (!removing) {
                setSelectedAlert(null)
              }
            }}
          />
        )}
      </div>
    </div>
  )
}

export default UserPageSearchAlerts
